interface RoleBadgeProps {
    role: string;
    className?: string;
}

export function RoleBadge({ role, className = '' }: RoleBadgeProps) {
    // Handle pro_user and pulse_user with SVG icons
    if (role === 'pro_user') {
        return (
            <span
                className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium gap-1 bg-white text-neutral-700 border border-neutral-200 ${className}`}
            >
                <img src="/pro-logo.svg" alt="Pro" className="w-4 h-4 object-contain" />
                Pro User
            </span>
        );
    }

    if (role === 'pulse_user') {
        return (
            <span
                className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium gap-1 bg-white text-neutral-700 border border-neutral-200 ${className}`}
            >
                <img src="/pulse-logo.svg" alt="Pulse" className="w-4 h-4 object-contain" />
                Pulse User
            </span>
        );
    }

    if (role === 'pro_restricted') {
        return (
            <span
                className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium gap-1 bg-white text-neutral-700 border border-neutral-200 ${className}`}
            >
                <img src="/pro-logo.svg" alt="Pro" className="w-4 h-4 object-contain" />
                Pro Restricted
            </span>
        );
    }

    if (role === 'pro_approver') {
        return (
            <span
                className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium gap-1 bg-white text-neutral-700 border border-neutral-200 ${className}`}
            >
                <img src="/pro-logo.svg" alt="Pro" className="w-4 h-4 object-contain" />
                Pro Approver
            </span>
        );
    }

    // For all other roles, display as text (cleaned up)
    const displayText = role.replace('organization_', '').replace('_', ' ');

    return (
        <span
            className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-white text-neutral-700 border border-neutral-200 ${className}`}
        >
            {displayText}
        </span>
    );
}
